import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation } from 'swiper/modules';
import { Swiper as SwiperClass } from 'swiper/core';
import { NavigationOptions } from 'swiper/types';
import BookCard from "./BookCard";
import { Book } from "../../types/types";
import { Key } from "react";
interface CustomSwiper extends SwiperClass {
    params: {
        navigation: NavigationOptions;
    };
}

interface BooksCarouselProps {
    prevRef: React.RefObject<HTMLButtonElement>;
    nextRef: React.RefObject<HTMLButtonElement>;
    books: Book[]; 

}

const BooksCarousel = ({ prevRef, nextRef , books }: BooksCarouselProps) => {
    return (
        <Swiper
            modules={[Navigation]}
            loop={true}
            breakpoints={{
                0: {
                    slidesPerView: 1.1,
                    spaceBetween: 16,
                },

                600: {
                    slidesPerView: 1.7,
                    spaceBetween: 16,
                },
                768: {
                    slidesPerView: 2.4,
                    spaceBetween: 16,
                },

                                1050: {
                    slidesPerView: 3,
                    spaceBetween: 28,
                },
            }}
            autoplay={{
                delay: 2500,
                disableOnInteraction: true,
            }}
            navigation={{
                prevEl: prevRef.current,
                nextEl: nextRef.current,
            }}
            onBeforeInit={(swiper) => {
                const customSwiper = swiper as unknown as CustomSwiper;
                customSwiper.params.navigation.prevEl = prevRef.current;
                customSwiper.params.navigation.nextEl = nextRef.current;
            }}

            className="mySwiper max-w-full !overflow-hidden"
        >
            {books.map((book: Book, index: Key | null | undefined) => (
                <SwiperSlide key={index} className="ease-in-out duration-300 transition-all !h-auto xl:min-w-[364px]">
                    <BookCard book={book} />
                </SwiperSlide>
            ))}
        </Swiper>
    )
}

export default BooksCarousel